import * as yup from 'yup';

export const UserSchema = yup.object().shape({
  nome: yup
    .string()
    .required('Campo nome é obrigatório')
    .trim(),
  cpf: yup
    .string()
    .typeError('CPF inválido.')
    .required('CPF é obrigatório.'),
  cargo: yup
    .string()
    .trim()
    .required('Campo obrigatório'),
  email: yup
    .string()
    .trim()
    .required('Campo obrigatório'),
  telefone: yup.number().required('Campo obrigatório'),
});
